import { render } from "./registerEvent.vue?vue&type=template&id=0b86bb63"
import script from "./registerEvent.vue?vue&type=script&lang=js"
export * from "./registerEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__